import React from 'react';
import { Card, Progress, Row, Col, Typography } from 'antd';
import { TrophyOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const { Title, Text } = Typography;

const StyledCard = styled(Card)`
  .level-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .level-info {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .level-badge {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 24px;
  }
  .points-info {
    text-align: right;
  }
`;

interface LevelProgressProps {
  level: number;
  points: number;
  nextLevelPoints: number;
  loading?: boolean;
}

const POINTS_PER_LEVEL = 500;

const LevelProgress: React.FC<LevelProgressProps> = ({
  level,
  points,
  nextLevelPoints,
  loading = false
}) => {
  const currentLevelPoints = (level - 1) * POINTS_PER_LEVEL;
  const pointsInCurrentLevel = points - currentLevelPoints;
  const pointsNeededForNext = nextLevelPoints - points;
  const progressPercent = (pointsInCurrentLevel / POINTS_PER_LEVEL) * 100;

  return (
    <StyledCard bordered={false} loading={loading}>
      <div className="level-header">
        <div className="level-info">
          <div className="level-badge">
            <TrophyOutlined />
          </div>
          <div>
            <Title level={4} style={{ margin: 0 }}>Level {level}</Title>
            <Text type="secondary">Naturalist</Text>
          </div>
        </div>
        <div className="points-info">
          <Title level={4} style={{ margin: 0 }}>{points.toLocaleString()}</Title>
          <Text type="secondary">Total Points</Text>
        </div>
      </div>

      <Progress
        percent={progressPercent}
        showInfo={false}
        strokeColor={{
          '0%': '#667eea',
          '100%': '#764ba2',
        }}
        strokeWidth={12}
      />

      <Row justify="space-between" style={{ marginTop: 12 }}>
        <Col>
          <Text type="secondary">{pointsInCurrentLevel} / {POINTS_PER_LEVEL} XP</Text>
        </Col>
        <Col>
          <Text type="secondary">{pointsNeededForNext} to Level {level + 1}</Text>
        </Col>
      </Row>
    </StyledCard>
  );
};

export default LevelProgress;
